import { render } from "./TrainConfigTagsCell.vue?vue&type=template&id=1ab0f622"
import script from "./TrainConfigTagsCell.vue?vue&type=script&lang=js"
export * from "./TrainConfigTagsCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__